import { create } from "zustand";

/** A short confirmation for an action that is otherwise invisible ("Copy
 * diagnostics" until it is pasted). The native apps show the same line in
 * their info toast. */
interface NoticeToastState {
  message?: string;
  show: (message: string) => void;
  dismiss: () => void;
}

let dismissTimer: ReturnType<typeof setTimeout> | undefined;

export const useNoticeToast = create<NoticeToastState>((set) => ({
  show: (message) => {
    if (dismissTimer) clearTimeout(dismissTimer);
    set({ message });
    dismissTimer = setTimeout(() => set({ message: undefined }), 4_000);
  },
  dismiss: () => {
    if (dismissTimer) clearTimeout(dismissTimer);
    dismissTimer = undefined;
    set({ message: undefined });
  },
}));
